<template>
  <a-card class="register-form-card">
    <ValidationObserver ref="observer">
      <a-form
        :label-width="80"
        slot-scope="{ validate, invalid }"
        @submit.prevent="
          () => {
            submitted = true;
            validate().then(handleSubmit);
          }
        "
      >
        <h2 class="title">{{ labels.title }}</h2>
        <a-row
          type="flex"
          justify="center"
          :style="{ alignItems: 'center' }"
          :gutter="[24, 24]"
        >
          <a-col :md="12" :sm="24" :xs="24">
            <Input
              v-model="form.firstname"
              rules="required"
              vid="firstname"
              :placeholder="labels.form.firstname.placeholder"
              size="large"
              :allowClear="true"
              :label="labels.form.firstname.label"
              @input="onlyAlfa($event, 'firstname')"
            />
          </a-col>
          <a-col :md="12" :sm="24" :xs="24">
            <Input
              v-model="form.lastname"
              rules="required"
              vid="lastname"
              :placeholder="labels.form.lastname.placeholder"
              size="large"
              :allowClear="true"
              :label="labels.form.lastname.label"
            />
          </a-col>
        </a-row>
        <a-row
          type="flex"
          justify="center"
          :style="{ alignItems: 'center' }"
          :gutter="[24, 24]"
        >
          <a-col :md="12" :sm="24" :xs="24">
            <Input
              v-model="form.identification_card"
              rules="required"
              vid="identification_card"
              :placeholder="labels.form.identificationCard.placeholder"
              size="large"
              :allowClear="true"
              :label="labels.form.identificationCard.label"
              v-mask="'###-#######-#'"
            />
          </a-col>
          <a-col :md="12" :sm="24" :xs="24">
            <!-- SEXO RADIO -->
            <ValidationProvider
              :name="labels.form.gender.label"
              rules="required"
              v-slot="{ errors }"
            >
              <a-form-item
                :label="labels.form.gender.label"
                :validateStatus="errors.length > 0 ? 'error' : ''"
                :help="errors[0]"
              >
                <a-radio-group v-model="form.gender" :size="'large'">
                  <a-radio :value="'M'">{{ labels.form.gender.male }}</a-radio>
                  <a-radio :value="'F'">{{
                    labels.form.gender.female
                  }}</a-radio>
                  <a-radio :value="'O'">{{ labels.form.gender.other }}</a-radio>
                </a-radio-group>
              </a-form-item>
            </ValidationProvider>
          </a-col>
        </a-row>
        <a-row
          type="flex"
          justify="center"
          :style="{ alignItems: 'center' }"
          :gutter="[24, 24]"
        >
          <a-col :md="12" :sm="24" :xs="24">
            <validation-provider
              :name="labels.form.birthdate.label"
              rules="required"
              v-slot="{ errors }"
            >
              <DateSelector
                v-model="form.birthdateObject"
                :vid="labels.form.birthdate.label"
                :name="labels.form.birthdate.label"
                :formitem="{ label: labels.form.birthdate.label }"
                :placeholder="labels.form.birthdate.placeholder"
                rules="required"
                class="datepicker-birthdate"
                :errors="invalid && submitted ? errors[0] : ''"
              />
            </validation-provider>
          </a-col>
          <a-col :md="12" :sm="24" :xs="24">
            <Input
              v-model="form.city"
              rules="required"
              vid="city"
              :placeholder="labels.form.birthplace.placeholder"
              size="large"
              :allowClear="true"
              :label="labels.form.birthplace.label"
            />
          </a-col>
        </a-row>
        <a-row
          type="flex"
          justify="center"
          :style="{ alignItems: 'center' }"
          :gutter="[24, 24]"
        >
          <a-col :md="12" :sm="24" :xs="24">
            <div class="whatsapp-container">
              <select-component
                v-model="form.whatsapp_country"
                :label="labels.form.country.label"
                :placeholder="labels.form.country.placeholder"
                :data="getCountries"
                rules="required"
                vid="whatsapp_country"
                labelKey="name"
                valueKey="id"
                style="width: 110px"
                class="country-select"
                :customStyle="{ minWidth: '400px' }"
                @change="handleCountryChange"
                :key="form.whatsapp_country?.id || '0'"
              >
                <template v-slot:renderOption="{ data }">
                  <country-with-flag :country="data" />
                </template>
              </select-component>
              <Input
                style="width: 100%"
                v-model="form.whatsapp"
                :label="labels.form.whatsapp.label"
                rules="required"
                vid="whatsapp"
                :placeholder="labels.form.whatsapp.placeholder"
                size="large"
                :allowClear="true"
                :maxLength="14"
                v-mask="'(###) ###-####'"
              />
            </div>
          </a-col>
          <a-col :md="12" :sm="24" :xs="24">
            <Input
              v-model="form.nationality"
              rules="required"
              vid="nationality"
              :placeholder="labels.form.nationality.placeholder"
              size="large"
              :allowClear="true"
              :label="labels.form.nationality.label"
            />
          </a-col>
          <a-col :sm="24" :xs="24">
            <Input
              v-model.trim="form.email"
              rules="required|validEmail"
              vid="email"
              :placeholder="labels.form.email.placeholder"
              size="large"
              :allowClear="true"
              :label="labels.form.email.label"
              @input="onlyLowecaseValidEmail($event, 'email')"
              :transform="($event) => $event.replaceAll(' ', '')"
            />
          </a-col>
        </a-row>
        <a-row
          type="flex"
          justify="center"
          :style="{ alignItems: 'center' }"
          :gutter="[24, 24]"
        >
          <a-col :md="12" :sm="24" :xs="24">
            <Input
              type="password"
              v-model="form.password"
              rules="required"
              vid="password"
              :placeholder="labels.form.password.placeholder"
              size="large"
              :allowClear="true"
              :label="labels.form.password.label"
              refs="password"
            />
          </a-col>
          <a-col :md="12" :sm="24" :xs="24">
            <Input
              type="password"
              v-model="form.password_confirmation"
              rules="required|confirmed:password"
              vid="password_confirmation"
              :placeholder="labels.form.passwordConfirm.placeholder"
              size="large"
              :allowClear="true"
              :label="labels.form.passwordConfirm.label"
            />
          </a-col>
        </a-row>
        <a-row
          type="flex"
          justify="center"
          :style="{ alignItems: 'center' }"
          :gutter="[24, 24]"
        >
          <a-col :sm="24" :xs="24">
            <TextArea
              v-model.trim="form.address"
              vid="address"
              :placeholder="labels.form.residenceAddress.placeholder"
              size="large"
              :allowClear="true"
              :label="labels.form.residenceAddress.label"
            />
          </a-col>
        </a-row>
        <!-- CHECKBOX TERM AND CONDITIONS -->
        <a-row
          type="flex"
          justify="center"
          :style="{ alignItems: 'center' }"
          :gutter="[24, 24]"
        >
          <a-col :md="24" :sm="24" :xs="24">
            <a-form-item>
              <Checkbox
                vid="acept_terms"
                v-model="form.acept_terms"
                :rules="'required'"
                :label="labels.form.aceptTerms"
                class="checkbox-terms"
              >
                <template v-slot:label>
                  <span class="text-terms">
                    {{ labels.form.agreeWidth }}
                    <router-link
                      class="link"
                      :to="{ name: 'terms-and-conditions' }"
                      target="_blank"
                      >{{ labels.form.terms }}</router-link
                    >
                    y nuestra
                    <router-link
                      class="link"
                      :to="{ name: 'privacy-policies' }"
                      target="_blank"
                      >{{ labels.form.privacityPolicy }}</router-link
                    >
                  </span>
                </template>
              </Checkbox>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row
          v-if="false"
          type="flex"
          :justify="hasReferralCode ? 'end' : 'start'"
          :style="{ alignItems: 'center' }"
          :gutter="[24, 24]"
        >
          <a-col :md="12" :sm="24" :xs="24">
            <Input
              v-model="form.promotion_code"
              vid="promotion_code"
              :placeholder="labels.form.promotion_code.placeholder"
              size="large"
              :allowClear="true"
              :label="labels.form.promotion_code.label"
              refs="promotion_code"
              :readOnly="hasPromotionCode"
              @input="onlyAlfaNumbericUpperCase($event, 'promotion_code')"
            />
          </a-col>
          <a-col v-if="hasReferralCode" :md="12" :sm="24" :xs="24">
            <Input
              v-model.trim="form.referral_code"
              vid="referral_code"
              :placeholder="labels.form.referralCode.placeholder"
              size="large"
              :allowClear="true"
              :label="labels.form.referralCode.label"
              :disabled="hasReferralCode"
              :readOnly="hasReferralCode"
              @input="onlyAlfaNumbericUpperCase($event, 'referral_code')"
            />
          </a-col>
        </a-row>
        <a-row
          v-if="false"
          type="flex"
          justify="center"
          :style="{ alignItems: 'center' }"
          :gutter="[24, 24]"
        >
          <a-col v-if="false" :md="24" :sm="24" :xs="24">
            <RecaptchaCheckbox
              v-model="form.recaptchaToken"
              vid="recaptcha"
              :label="'recaptcha'"
              :onChange="onChangeRecaptcha"
            />
          </a-col>
          <a-col :md="24" :sm="24" :xs="24">
            <a-form-item>
              <a-checkbox v-model="form.acept_terms">
                {{ labels.form.agreeWidth }}
                <router-link
                  class="link"
                  :to="{ name: 'privacy-policies' }"
                  target="_blank"
                  >{{ labels.form.privacityPolicy }}</router-link
                >,
                <router-link
                  class="link"
                  :to="{ name: 'terms-and-conditions' }"
                  target="_blank"
                  >{{ labels.form.terms }}</router-link
                >
              </a-checkbox>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row
          type="flex"
          justify="center"
          :style="{ alignItems: 'center' }"
          :gutter="[24, 24]"
        >
          <a-col :span="24">
            <a-row type="flex" justify="space-between" :gutter="8">
              <a-col>
                <a-form-item>
                  <a-button
                    type="link"
                    :loading="submitting"
                    :disabled="submitting || invalid ? false : false"
                    size="large"
                    class="btn-link"
                    @click.prevent="redirectToWhatApp"
                  >
                    <span>{{ labels.form.needHelp }}</span>
                  </a-button>
                </a-form-item>
              </a-col>
              <a-col>
                <!-- Subscribe button -->
                <a-form-item style="text-align: right">
                  <a-button
                    type="default"
                    html-type="submit"
                    :loading="submitting"
                    :disabled="submitting || invalid ? false : false"
                    size="large"
                    class="btn-send"
                    @click.prevent="
                      () => {
                        submitted = true;
                        validate().then(handleSubmit);
                      }
                    "
                  >
                    <span>{{ labels.form.submit }}</span>
                  </a-button>
                </a-form-item>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-form>
    </ValidationObserver>
  </a-card>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import { mapActions, mapGetters, mapState } from "vuex";
import _ from "lodash";
import { Modal } from "ant-design-vue";
import Input from "@/components/core/VeeValidateForm/Input";
import DateSelector from "@/components/core/VeeValidateForm/DateSelector";
import RecaptchaCheckbox from "@/components/core/VeeValidateForm/RecaptchaCheckbox";
import TextArea from "@/components/core/VeeValidateForm/TextArea";
import Checkbox from "@/components/core/VeeValidateForm/Checkbox";
import SelectComponent from "@/components/core/SelectPagination";
import CountryWithFlag from "@/components/register/CountryWithFlag";
import labels from "@/utils/labels";
import EventBus, { ListEvents } from "../event";
import { CRAUE_CONFIG, getCookie, rouletteCookieName } from "@/utils/utils";
import moment from "moment";
import { ValidationProvider } from "vee-validate";
const initialState = {
  firstname: "",
  lastname: "",
  email: "",
  referral_code: "",
  whatsapp: "",
  whatsapp_country: null,
  password: "",
  password_confirmation: "",
  province: undefined,
  address: "",
  city: "",
  acept_terms: false,
  not_robot: false,
  birthdateObject: "",
  birthdate: "",
  nationality: "",
  promotion_code: "",
  gender: "",
  // recaptchaToken: "",
};
export default {
  name: "RegisterForm",
  components: {
    ValidationObserver,
    Input,
    RecaptchaCheckbox,
    SelectComponent,
    CountryWithFlag,
    DateSelector,
    ValidationProvider,
    TextArea,
    Checkbox,
  },
  data() {
    return {
      form: _.cloneDeep(initialState),
      loading: false,
      submitting: false,
      verifyPhone: false,
      submitted: false,
      labels: {
        ...labels.registerForm,
        appName: labels.appName,
        unknownServerError: labels.unknownServerError,
      },
    };
  },
  async beforeCreate() {
    await this.$store.dispatch("fetchCountries");
  },
  created() {
    if (this.hasReferralCode) {
      this.form.referral_code =
        this.$route.query.r || this.$route.query.referralId;
    }
    if (this.hasPromotionCode) {
      this.form.promotion_code =
        this.$route.query.promotion_code || this.$route.query.p;
    }
  },
  async mounted() {
    if (!this.defaultCountry) {
      await this.fetchCountries();
    }
    this.form.whatsapp_country = [this.defaultCountry]; // TODO: Check this... (force to render default using array)
  },
  computed: {
    ...mapGetters(["getCountries", "defaultCountry"]),
    ...mapGetters({
      whatsapp: "systemConfig/getWhatsapp",
    }),
    ...mapState(["redirectRoute"]),
    hasReferralCode() {
      return !!this.$route.query?.r || !!this.$route.query?.referralId;
    },
    hasPromotionCode() {
      return !!this.$route.query?.promotion_code || !!this.$route.query?.p;
    },
    dateFormat() {
      return "DD/MM/YYYY";
    },
  },
  methods: {
    ...mapActions(["fetchProvincesSelect", "fetchCountries"]),
    ...mapActions("clientAuth", ["handleRegister", "setFromRegister"]),
    ...mapActions("systemConfig", ["getCraueConfigByNameClient"]),
    async getSystemConfig() {
      try {
        this.loading = true;
        const { data: verifyPhone } = await this.getCraueConfigByNameClient(
          CRAUE_CONFIG.VAR_VERIFY_PHONE
        );
        this.verifyPhone = verifyPhone?.value === "1";
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    confirmAceptTermsAndPolicy() {
      const policyURI = this.$router.resolve({ name: "privacy-policies" }).href;
      const termsURI = this.$router.resolve({
        name: "terms-and-conditions",
      }).href;
      this.$confirm({
        title: this.labels.confirm.title,
        centered: false,
        class: "confirm-policy-and-condition-modal",
        // JSX support
        content: (
          <div style="display:block;width:100%;">
            {this.labels.form.agreeWidth}{" "}
            <a class="link" href={policyURI} target="_blank">
              {this.labels.form.privacityPolicy}
            </a>
            ,{" "}
            <a class="link" href={termsURI} target="_blank">
              {this.labels.form.terms}
            </a>
          </div>
        ),
        cancelText: this.labels.confirm.cancelText,
        okText: this.labels.confirm.okText,
        okType: "primary",
        autoFocusButton: "ok",
        onCancel: async () => {
          this.form.acept_terms = false;
        },
        onOk: async () => {
          this.form.acept_terms = true;
          await this.handleSubmit();
        },
      });
    },
    goToLink(type) {
      const route = this.$router.resolve({
        name: "transaction-request",
        query: { type },
      });
      if (route.href !== this.$route.fullPath) this.$router.push(route.href);
    },
    async handleSubmit() {
      if (!!this.form.acept_terms === false) {
        this.$message.error(this.labels.form.acept_terms.required);
        return;
      }

      const today = moment();
      const age = today.diff(this.form.birthdateObject, "years");

      if (age < 18) {
        this.$message.error(this.labels.form.isMinor);
        return;
      }
      this.form.birthdate = this.form.birthdateObject.format("YYYY-MM-DD");

      if (!!this.form.acept_terms === false) {
        this.$message.error(this.labels.form.aceptTerms);
        return;
      }

      try {
        this.submitting = true;
        const data = _.cloneDeep(this.form);
        data.whatsapp_country = data.whatsapp_country[0];

        const winnerCookie = getCookie(rouletteCookieName);
        if (winnerCookie) {
          const promotion = JSON.parse(winnerCookie);
          if (promotion?.prize) {
            data.promocode = promotion.prize;
          }
        }

        await this.handleRegister(data);
        await this.getSystemConfig();
        this.setFromRegister(true);
        this.$nextTick(() => {
          this.$router.push({
            name: this.verifyPhone ? "verify-phone" : "welcome",
          });
        });
      } catch (error) {
        if (error.isAxiosError && error.response?.status === 401) {
          this.$error({
            title: this.labels.error,
            content:
              error.response?.data?.message ||
              error.message ||
              this.labels.form.errorMessage,
            centered: true,
          });
        } else if (error.isAxiosError && error.response.status === 400) {
          Modal.destroyAll();
          this.$error({
            title: `${error.response?.data?.message || error.message} ${
              error.response.status
            }`,
            centered: false,
            class: "error-modal",
            okType: "primary",
            autoFocusButton: "ok",
            okText: this.labels.accept,
            content: (h) =>
              h(
                "ul",
                { class: "error-list" },
                error.response?.data?.additional_errors?.map((error, index) =>
                  h("li", { class: "error-list-item", key: index }, error)
                )
              ),
          });
        } else {
          Modal.destroyAll();
          this.$notification["error"]({
            message: `${this.labels.error} ${
              error?.code || error?.response?.status || 500
            }`,
            description:
              error?.message ||
              error?.response?.data?.message ||
              this.labels.unknownServerError,
          });
        }
        EventBus.$emit(ListEvents.reset_recaptcha);
      } finally {
        this.submitting = false;
      }
    },
    async onlyAlfa(value = "", field) {
      this.form[field] = await value.replace(/[^a-zA-Z\s]/g, "");
    },
    async onlyAlfaNumbericUpperCase(value = "", field) {
      this.form[field] = await value
        .replace(/[^a-zA-Z0-9\s]/g, "")
        .toUpperCase();
    },
    async onlyLowecaseValidEmail(value = "", field) {
      this.form[field] = await value
        .replace(/[^a-zA-Z0-9_\-@.]/g, "")
        .replaceAll(" ", "")
        .toLowerCase()
        .trim();
    },
    onChangeRecaptcha(value) {
      this.form.not_robot = !!value;
    },
    handleCountryChange(country) {
      // Force render, bug if search is used
      this.$nextTick(() => {
        this.form.whatsapp_country = [country];
      });
    },
    redirectToWhatApp() {
      if (this.whatsapp) {
        const whatsappLink = `https://wa.me/${this.whatsapp.replaceAll(
          /[^0-9]/g,
          ""
        )}`;
        window.open(whatsappLink, "_blank");
      } else {
        this.$message.error(this.labels.form.errorMessage);
      }
    },
  },
};
</script>
<style lang="scss">
@import "~@/assets/scss/variable";
.register-form-card {
  background-color: var(--card-shop-bg);
  border-color: var(--card-shop-shadow);
  box-shadow: 0 0 2px var(--card-shop-shadow);
  padding: 3.125rem;
  border-radius: 8px;
  @media screen and (max-width: $screen-mobile) {
    padding: 2.125rem 1rem;
  }
  .title {
    font-family: "Exo 2", sans-serif;
    color: var(--text);
    font-weight: 400;
    margin: 0;
    line-height: 1.3;
    word-break: break-word;
    font-size: 2rem;
    margin-bottom: 1rem;
    text-align: center;
  }
  .ant-card-body {
    padding: 0;
  }
  .ant-form label {
    font-size: 0.875rem;
    color: var(--text);
    font-family: "Roboto", sans-serif;
  }
  .ant-input {
    background-color: var(--input-bg);
    color: var(--text);
    &:active,
    &:focus,
    &:hover {
      border-color: var(--text-active);
    }
  }
  .ant-input-affix-wrapper {
    .ant-input:not(:first-child) {
      padding-left: 2.8125rem;
    }
    .ant-input-prefix {
      color: var(--text);
      font-size: 1.375rem;
      font-family: "Roboto", sans-serif;
    }
    .ant-input-clear-icon,
    .ant-input-textarea-clear-icon,
    .ant-input-password-icon {
      color: var(--text);
    }
  }

  .has-error .ant-input-affix-wrapper .ant-input,
  .has-error .ant-input-affix-wrapper .ant-input:hover {
    background-color: var(--input-bg);
  }

  .btn-send {
    color: var(--btn-text-primary) !important;
    background-color: var(--btn-bg-primary);
    border-color: var(--btn-bc-primary);
    height: 51px;
    padding: 0 1.75rem;
    @media screen and (max-width: 596px) {
      width: 100% !important;
    }
  }

  .checkbox-terms {
    .ant-checkbox-wrapper {
      display: grid;
      align-items: center;
      grid-template-columns: auto 1fr;
      line-height: 1.6;
    }
    label {
      line-height: 1.6;
    }
  }

  .btn-link,
  .link {
    color: var(--text-active);
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    font-weight: 400;
    margin-left: 5px;
    text-decoration: underline;
  }
  .text-terms {
    color: var(--text);
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    font-weight: 400;
  }
  .btn-link {
    padding: 0;
    margin: 0;
    border-radius: 0;
    &:hover {
      span {
        text-decoration: underline;
      }
    }
  }

  .ant-select {
    .ant-select-selection--single {
      color: var(--text);
      background-color: var(--input-bg);
      border: 1px solid var(--text-muted);
      &:active,
      &:focus,
      &:hover {
        border-color: var(--text-active);
      }
      .anticon-down {
        color: var(--text);
      }
    }
  }

  .whatsapp-container {
    display: flex;
    align-items: flex-end;

    .country-select {
      .ant-select-selection {
        &--single,
        &__rendered {
          height: 40px;
          line-height: 40px;
          .country-label {
            display: none;
          }
        }
        &--single {
          width: 110px;
        }
      }
    }
  }

  .datepicker-birthdate {
    .ant-calendar-picker-input {
      height: 40px;
    }
  }
}

input:-internal-autofill-selected {
  background-color: var(--input-bg) !important;
  border-color: var(--text-active) !important;
  color: var(--text-muted) !important;
}

.custom-select {
  background-color: var(--input-bg) !important;
  .ant-select-dropdown-menu-item {
    color: var(--text) !important;
    &:hover {
      background-color: var(--input-bg) !important;
    }
    &-active {
      background-color: var(--input-bg) !important;
    }
  }
}
.error-modal,
.confirm-policy-and-condition-modal {
  .ant-modal-content {
    background-color: var(--modal-bg) !important;
    box-shadow: 0 1px 3px 3px var(--modal-shadow);
    .ant-modal-confirm-title {
      color: var(--text) !important;
    }
    .ant-modal-confirm-content {
      color: var(--text) !important;
      .link {
        color: var(--text-active);
        font-family: "Roboto", sans-serif;
        text-decoration: none;
        font-size: 1rem;
        font-weight: 500;
        margin-left: 5px;
        &:hover {
          text-decoration: underline;
        }
      }
      .error-list-item {
        font-size: 0.95rem;
        margin-bottom: 5px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .ant-modal-confirm-btns {
      .ant-btn {
        color: var(--btn-text-secondary) !important;
        background-color: var(--btn-bg-secondary);
        border-color: var(--btn-bc-secondary);
        &:hover,
        &:focus,
        &:active {
          color: var(--btn-text-secondary) !important;
          background-color: var(--btn-bg-secondary);
          border-color: var(--btn-bc-secondary);
        }
        &.ant-btn-primary {
          color: var(--btn-text-primary) !important;
          background-color: var(--btn-bg-primary);
          border-color: var(--btn-bc-primary);
          &:hover {
            color: var(--btn-text-primary) !important;
            background-color: var(--btn-bg-primary);
            border-color: var(--btn-bc-primary);
          }
        }
      }
    }
  }
}
</style>
